import { z } from 'zod';
import { ArgoConnectionKindEnum } from '../db';

export const connectionTerminatorSchema = z.union([ z.literal('none'), z.literal('crlf'), z.literal('lf'), z.literal('cr') ]);
export type ConnectionTerminator = z.infer<typeof connectionTerminatorSchema>;

export const tcpClientConnectionConfigSchema = z.object({
    kind: z.literal(ArgoConnectionKindEnum.TcpClient),
    details: z.object({
        ip: z.string(),
        port: z.number(),
        terminator: connectionTerminatorSchema,
    }),
});
export type TcpClientConnectionConfig = z.infer<typeof tcpClientConnectionConfigSchema>;
